import Loading from './Modules/Loading'
import Authentication from './Modules/Authentication'
import User from './Modules/User'
import Brand from './Modules/Brand'
import Category from './Modules/Category'
import Address from './Modules/Address'
import City from './Modules/City'
import Province from './Modules/Province'
import Feature from './Modules/Feature'
import Product from './Modules/Product'
import SiteInfo from './Modules/SiteInfo'
import ShoppingCart from './Modules/ShoppingCart'
import Offer from './Modules/Offer'
import Transaction from './Modules/Transaction'
import Content from './Modules/Content'
import Course from './Modules/Course'
import FileManager from './Modules/FileManager'
import Menu from './Modules/Menu'
import Comment from './Modules/Comment'
import Timing from './Modules/Timing'
import Ticket from './Modules/Ticket'
import Meta from './Modules/Meta'
import Search from './Modules/Search'

const modulesPaths = {
    Loading,
    Authentication,
    User,
    Brand,
    Category,
    Address,
    City,
    Province,
    Feature,
    Product,
    SiteInfo,
    ShoppingCart,
    Offer,
    Transaction,
    Content,
    Course,
    FileManager,
    Menu,
    Comment,
    Timing,
    Ticket,
    Meta,
    Search,
}

export default modulesPaths